<template>
  <a-layout-content :style="{ margin: '24px 16px', padding: '24px', minHeight: '100vh' }">
    <template v-if="!loading">
      <a-row :gutter="40">
        <a-col :span="24" class="gutter-row wemail-campaign-overview">
          <h3>Campaign Overview</h3>
          <a-button v-if="overview.status === 'active'">
            <i class="fa fa-pause"></i>
            <span>&nbsp;&nbsp;Pause Campaign</span>
          </a-button>
        </a-col>
      </a-row>
      <div style="background-color: #fff; padding: 20px;" v-if="overview.email">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-list bordered>
              <a-list-item>
                <p>Status</p>
                <span class="wemail-success">{{overview.status}}</span>
              </a-list-item>
              <a-list-item>
                <p>Name</p>
                <span>{{overview.name}}</span>
              </a-list-item>
              <a-list-item>
                <p>Subject</p>
                <span>{{overview.email.subject}}</span>
              </a-list-item>
              <a-list-item>
                <p>Lists</p>
                <span v-for="(list, index) in overview.lists" :key="index">
                  <router-link
                    tag="a"
                    :to="{name: 'sites.lists.subscribers', params: {
                      siteId: overview.site_id,
                      listId: list.id
                    }}"
                  >{{ list.name }}</router-link>&nbsp;
                </span>
              </a-list-item>
              <a-list-item>
                <p>From</p>
                <span>{{overview.email.from_email}}</span>
              </a-list-item>
              <a-list-item>
                <p>Reply To</p>
                <span>{{overview.email.reply_to_email}}</span>
              </a-list-item>
              <div slot="header">Summary</div>
            </a-list>
          </a-col>
          <a-col :span="12">
            <a-list bordered>
              <div slot="header">Email Status</div>
              <pie-graph></pie-graph>
            </a-list>
          </a-col>
        </a-row>
      </div>
      <div style="margin-top:20px">
        <ClickByCountry/>
      </div>
    </template>
    <template v-else>
      <div class="loader-container">
        <a-spin :size="'large'" />
      </div>
    </template>
  </a-layout-content>
</template>
<script>
import PieGraph from "@/components/PieGraph.vue";
import ClickByCountry from "@/components/ClickByCountry.vue";
import CampaignSendingStats from "@/components/CampaignSendingStats.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      loading: true
    }
  },
  components: {
    PieGraph,
    ClickByCountry,
    CampaignSendingStats
  },
  computed: {
    ...mapGetters({
      overview: "campaigns/overview",
      stats: "campaigns/sendingStats"
    })
  },
  methods: {
    async getCampaignOverview() {
      await this.$store.dispatch(
        "campaigns/GET_OVERVIEW",
        this.$route.params.campaignId
      );
    },
    async getCountryWiseData() {
      await this.$store.dispatch(
        "campaigns/GET_COUNTRY_WISE",
        this.$route.params.campaignId
      );
    },
    async getSendingStats() {
      await this.$store.dispatch(
        "campaigns/GET_SENDING_STATS",
        this.$route.params.campaignId
      );
    },
    async pauseCampaign() {
      await this.$store.dispatch("campaigns/Pause", this.$route.params.campaignId);
    },
    async dispatchActions() {
      this.loading = true;
      await this.getCampaignOverview();
      await this.getSendingStats();
      await this.getCountryWiseData();
      this.loading = false;
    }
  },
  created() {
    this.dispatchActions();
  }
};
</script>

<style scoped>
.ant-list-item:nth-child(odd) {
  background: #f9f9f9;
}
.ant-list-item {
  display: flex;
  align-items: center;
}
.ant-list-item p {
  font-weight: 600;
  margin: 0;
  flex-basis: 150px;
}
.ant-list-item span.wemail-primary {
  color: #007bff;
}
.ant-list-item span.wemail-success {
  color: #28a745;
}
.ant-list-item span.wemail-error {
  color: #dc3545;
}
.ant-list-item span.wemail-warning {
  color: #ffc107;
}
.wemail-campaign-overview h3 {
  display: inline-block;
}
.wemail-campaign-overview button {
  float: right;
  margin: 5px;
}
</style>


